export type EditorMode = 'edit' | 'design';

export const EDIT_PANE_MIN_HEIGHT = 260;
export const EDIT_DIVIDER_HEIGHT = 12;
export const DEFAULT_EDIT_PREVIEW_PANE_RATIO = 0.55;

export function clampEditPreviewPaneHeight(
  requestedHeight: number | null,
  workspaceHeight: number
): number {
  const availableHeight = Math.max(0, workspaceHeight - EDIT_DIVIDER_HEIGHT);
  const maximumHeight = Math.max(EDIT_PANE_MIN_HEIGHT, availableHeight - EDIT_PANE_MIN_HEIGHT);
  const defaultHeight = Math.round(availableHeight * DEFAULT_EDIT_PREVIEW_PANE_RATIO);
  const nextHeight = requestedHeight ?? defaultHeight;

  return Math.max(EDIT_PANE_MIN_HEIGHT, Math.min(nextHeight, maximumHeight));
}
